import { SearchableDropdown } from '@startupquickstart/frontend';

interface GreaterAreaDropdownProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
}

/** Single-select dropdown of greater areas, sourced from the `/greater-areas` endpoint. */
export function GreaterAreaDropdown({
  value,
  onChange,
  placeholder = 'Select greater area',
  className,
}: GreaterAreaDropdownProps) {
  return (
    <SearchableDropdown
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      searchPlaceholder="Search greater areas..."
      className={className}
      endpoint="greater-areas"
      emptyText="No greater areas found."
    />
  );
}
